(function () {
  "use strict";

  var root = document.querySelector("[data-hairplus-bundle]");
  if (!root) return;

  var cartRoot =
    (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var fallbackVariantId = parseInt(root.dataset.variantId, 10);
  var productAvailable = root.dataset.productAvailable !== "false";
  var options = root.querySelectorAll("[data-dsb-option]");
  var totalEl = root.querySelector("[data-dsb-total]");
  var addBtn = root.querySelector("[data-dsb-add]");
  var addLabel = root.querySelector("[data-dsb-add-label]");
  var adding = false;
  var syncing = false;

  var variants = [];
  try {
    var variantsEl = root.querySelector("[data-dsb-variants]");
    if (variantsEl) variants = JSON.parse(variantsEl.textContent) || [];
  } catch (_) {}

  function normalizeColor(value) {
    return String(value || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim();
  }

  function toneClass(value) {
    var n = normalizeColor(value);
    if (n.indexOf("negro") !== -1) return "dsb-swatch--negro";
    if (n.indexOf("casta") !== -1) return "dsb-swatch--castano";
    return "";
  }

  function variantForColor(color) {
    var norm = normalizeColor(color);
    return (
      variants.find(function (v) {
        return normalizeColor(v.color) === norm;
      }) || null
    );
  }

  function colorSellable(color) {
    var v = variantForColor(color);
    if (!v) return false;
    if (v.available === false) return false;
    if (v.inventory_management && v.inventory_policy !== "continue") {
      var q = Number(v.inventory_quantity);
      if (!isNaN(q) && q <= 0) return false;
    }
    return true;
  }

  function stockForColor(color) {
    var v = variantForColor(color);
    if (!v || !colorSellable(color)) return 0;
    if (v.inventory_management && v.inventory_policy !== "continue") {
      var q = Number(v.inventory_quantity);
      if (!isNaN(q)) return Math.max(0, q);
    }
    return 9999;
  }

  function closeDropdown(dd) {
    dd.classList.remove("is-open");
    var trigger = dd.querySelector("[data-color-dropdown-trigger]");
    var panel = dd.querySelector("[data-color-dropdown-panel]");
    if (trigger) trigger.setAttribute("aria-expanded", "false");
    if (panel) panel.hidden = true;
  }

  function applySwatch(dd, value) {
    var swatch = dd.querySelector("[data-dsb-swatch]");
    if (!swatch) return;
    swatch.className = "dsb-swatch";
    if (!value) {
      swatch.hidden = true;
      return;
    }
    var cls = toneClass(value);
    if (cls) swatch.classList.add(cls);
    swatch.hidden = false;
  }

  function initColorDropdowns() {
    root.querySelectorAll("[data-color-dropdown]").forEach(function (dd) {
      if (dd.dataset.colorDropdownInit) return;
      dd.dataset.colorDropdownInit = "1";

      var select = dd.querySelector("[data-dsb-color]");
      var trigger = dd.querySelector("[data-color-dropdown-trigger]");
      var label = dd.querySelector("[data-color-dropdown-label]");
      var panel = dd.querySelector("[data-color-dropdown-panel]");
      var optionBtns = dd.querySelectorAll("[data-color-option]");
      if (!select || !trigger || !panel) return;

      function setValue(value, optionBtn, silent) {
        var empty = !value;
        select.value = empty ? "" : value;
        dd.classList.toggle("dsb-dd--empty", empty);
        if (label) {
          label.textContent = empty
            ? "Elegí color"
            : (optionBtn && optionBtn.dataset.colorName) || value;
        }
        applySwatch(dd, value);
        optionBtns.forEach(function (opt) {
          var on = optionBtn ? opt === optionBtn : opt.dataset.value === value;
          opt.classList.toggle("is-selected", on);
          opt.setAttribute("aria-selected", on ? "true" : "false");
        });
        if (!silent) {
          select.dispatchEvent(new Event("change", { bubbles: true }));
        }
      }

      dd.applyColorValue = function (colorValue, silent) {
        if (!colorValue) {
          setValue("", null, silent);
          return;
        }
        var match = null;
        optionBtns.forEach(function (opt) {
          if (opt.dataset.value === colorValue) match = opt;
        });
        setValue(colorValue, match, silent);
      };

      trigger.addEventListener("click", function (e) {
        e.stopPropagation();
        if (dd.classList.contains("is-open")) {
          closeDropdown(dd);
          return;
        }
        root.querySelectorAll("[data-color-dropdown].is-open").forEach(closeDropdown);
        dd.classList.add("is-open");
        trigger.setAttribute("aria-expanded", "true");
        panel.hidden = false;
      });

      optionBtns.forEach(function (opt) {
        opt.addEventListener("click", function (e) {
          e.stopPropagation();
          if (opt.disabled || opt.classList.contains("is-sold-out")) return;
          setValue(opt.dataset.value, opt);
          closeDropdown(dd);
        });
      });
    });
  }

  document.addEventListener("click", function () {
    root.querySelectorAll("[data-color-dropdown].is-open").forEach(closeDropdown);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      root.querySelectorAll("[data-color-dropdown].is-open").forEach(closeDropdown);
    }
  });

  function getSelected() {
    return root.querySelector("[data-dsb-option].is-selected");
  }

  function getQty() {
    var sel = getSelected();
    return sel ? parseInt(sel.dataset.qty, 10) || 1 : 1;
  }

  function colorSelects(card) {
    return card ? card.querySelectorAll("[data-dsb-color]") : [];
  }

  function countColorInCard(card, color, excludeSelect) {
    var n = 0;
    colorSelects(card).forEach(function (sel) {
      if (excludeSelect && sel === excludeSelect) return;
      if (sel.value === color) n += 1;
    });
    return n;
  }

  function canAssign(color, card, slotSelect) {
    if (!color || stockForColor(color) <= 0) return false;
    return countColorInCard(card, color, slotSelect) + 1 <= stockForColor(color);
  }

  function preferredColors() {
    var list = [];
    var seen = {};
    variants.forEach(function (v) {
      var color = v.color;
      var key = normalizeColor(color);
      if (color && !seen[key]) {
        seen[key] = true;
        list.push(color);
      }
    });
    list.sort(function (a, b) {
      var an = normalizeColor(a).indexOf("negro") !== -1 ? 0 : 1;
      var bn = normalizeColor(b).indexOf("negro") !== -1 ? 0 : 1;
      return an - bn;
    });
    return list;
  }

  function defaultColor(card, slotSelect) {
    var order = preferredColors();
    for (var i = 0; i < order.length; i++) {
      if (canAssign(order[i], card, slotSelect)) return order[i];
    }
    return "";
  }

  function updateColorAvailability(card) {
    if (!card) return;
    card.querySelectorAll("[data-color-dropdown]").forEach(function (dd) {
      var select = dd.querySelector("[data-dsb-color]");
      dd.querySelectorAll("[data-color-option]").forEach(function (opt) {
        var color = opt.dataset.value;
        if (!color) return;
        var soldOut =
          select && select.value === color
            ? stockForColor(color) <= 0
            : !canAssign(color, card, select);
        var name = opt.dataset.colorName || color;
        var nameEl = opt.querySelector(".dsb-dd__option-name");
        opt.disabled = soldOut;
        opt.classList.toggle("is-sold-out", soldOut);
        opt.setAttribute("aria-disabled", soldOut ? "true" : "false");
        if (nameEl) nameEl.textContent = soldOut ? name + " — Agotado" : name;
      });
      if (select) {
        Array.prototype.forEach.call(select.options, function (opt) {
          if (!opt.value) return;
          opt.disabled = !canAssign(opt.value, card, select) && select.value !== opt.value
            ? true
            : stockForColor(opt.value) <= 0 && select.value !== opt.value;
          if (select.value === opt.value) opt.disabled = stockForColor(opt.value) <= 0;
        });
      }
    });
  }

  function fillDefaultColors(card) {
    if (!card) return;
    syncing = true;
    colorSelects(card).forEach(function (sel) {
      var dd = sel.closest("[data-color-dropdown]");
      if (sel.value && !colorSellable(sel.value)) {
        if (dd && dd.applyColorValue) dd.applyColorValue("", true);
      }
    });
    colorSelects(card).forEach(function (sel) {
      if (sel.value) return;
      var color = defaultColor(card, sel);
      var dd = sel.closest("[data-color-dropdown]");
      if (color && dd && dd.applyColorValue) dd.applyColorValue(color, true);
    });
    syncing = false;
  }

  function lineItemsFromCard(card) {
    var selects = colorSelects(card);
    var qty = parseInt(card.dataset.qty, 10) || 1;
    var byVariant = {};

    if (!selects.length) {
      var fallback =
        variants.find(function (v) {
          return v.available;
        }) ||
        variants[0] ||
        (fallbackVariantId ? { id: fallbackVariantId } : null);
      if (fallback) {
        byVariant[fallback.id] = {
          id: fallback.id,
          quantity: qty,
          properties: { _hairplus_bundle: "1" },
        };
      }
      return Object.keys(byVariant).map(function (k) {
        return byVariant[k];
      });
    }

    selects.forEach(function (sel) {
      if (!sel.value) return;
      var variant = variantForColor(sel.value);
      if (!variant || !colorSellable(sel.value)) return;
      var id = String(variant.id);
      if (!byVariant[id]) {
        byVariant[id] = {
          id: variant.id,
          quantity: 0,
          properties: { _hairplus_bundle: "1" },
        };
      }
      byVariant[id].quantity += 1;
    });

    return Object.keys(byVariant).map(function (k) {
      return byVariant[k];
    });
  }

  function updateUI() {
    var sel = getSelected();
    if (!sel) return;
    var qty = getQty();
    var totalLabel = sel.dataset.totalLabel || "";
    if (totalEl) totalEl.textContent = totalLabel;

    var items = lineItemsFromCard(sel);
    var filled = 0;
    colorSelects(sel).forEach(function (s) {
      if (s.value) filled += 1;
    });
    var hasColorSlots = colorSelects(sel).length > 0;
    var stockOk = items.length > 0 && items.every(function (item) {
      var v = variants.find(function (x) {
        return Number(x.id) === Number(item.id);
      });
      if (!v) return !!item.id;
      return stockForColor(v.color) >= item.quantity;
    });
    var canAdd =
      productAvailable &&
      stockOk &&
      (!hasColorSlots || filled > 0);

    if (addBtn) addBtn.disabled = !canAdd || adding;
    if (addLabel) {
      if (!productAvailable || !canAdd) {
        addLabel.textContent = "Sin stock momentáneo";
      } else if (hasColorSlots && filled < qty) {
        addLabel.textContent = "Agregar " + filled + " al carrito";
      } else if (qty > 1) {
        addLabel.textContent = "Agregar " + qty + " al carrito";
      } else {
        addLabel.textContent = "Agregar al carrito";
      }
    }
  }

  function selectOption(opt) {
    options.forEach(function (el) {
      var on = el === opt;
      el.classList.toggle("is-selected", on);
      var btn = el.querySelector("[data-dsb-select]");
      if (btn) btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
    fillDefaultColors(opt);
    updateColorAvailability(opt);
    updateUI();
  }

  options.forEach(function (opt) {
    var btn = opt.querySelector("[data-dsb-select]");
    if (btn) {
      btn.addEventListener("click", function () {
        selectOption(opt);
      });
    }
  });

  root.querySelectorAll("[data-dsb-color]").forEach(function (sel) {
    sel.addEventListener("change", function () {
      if (syncing) return;
      var card = sel.closest("[data-dsb-option]");
      updateColorAvailability(card);
      updateUI();
    });
  });

  function addToCart() {
    if (!addBtn || addBtn.disabled || adding) return;
    var card = getSelected();
    if (!card) return;
    var items = lineItemsFromCard(card);
    if (!items.length) return;

    adding = true;
    addBtn.disabled = true;
    if (addLabel) addLabel.textContent = "Agregando…";

    fetch(cartRoot + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ items: items }),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) {
            var err = new Error(
              (data && (data.description || data.message)) ||
                "No pudimos agregar al carrito.",
            );
            err.data = data;
            throw err;
          }
          return data;
        });
      })
      .then(function () {
        adding = false;
        updateUI();
        if (window.HairplusCart && typeof window.HairplusCart.refresh === "function") {
          window.HairplusCart.refresh().then(function () {
            window.HairplusCart.open();
          });
        } else {
          document.dispatchEvent(new CustomEvent("hairplus:cart-updated"));
        }
      })
      .catch(function (err) {
        adding = false;
        updateUI();
        window.alert(
          (err && err.message) ||
            "No pudimos agregar al carrito. Probá de nuevo.",
        );
      });
  }

  if (addBtn) addBtn.addEventListener("click", addToCart);

  document.querySelectorAll("[data-dsb-scroll]").forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      root.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  });

  if (window.location.hash === "#hairplus-bundle") {
    setTimeout(function () {
      root.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
  }

  initColorDropdowns();
  var selected = getSelected();
  fillDefaultColors(selected);
  updateColorAvailability(selected);
  updateUI();
})();
